// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_carousel-module__chips--x6AcM{height:25px;overflow:hidden;position:relative;white-space:nowrap}.common_carousel-module__chips--x6AcM ::-webkit-scrollbar{width:0 !important;display:none !important}.common_carousel-module__wrapper--2piiH{white-space:nowrap;overflow-x:scroll;-webkit-overflow-scrolling:touch;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.common_carousel-module__inner--3dkau{margin:0px 5px 5px 2px}\n", ""]);
// Exports
exports.locals = {
	"chips": "common_carousel-module__chips--x6AcM",
	"wrapper": "common_carousel-module__wrapper--2piiH",
	"inner": "common_carousel-module__inner--3dkau"
};
module.exports = exports;
